import React from 'react'
import { Outlet } from 'react-router-dom'

export default function StudentIndex() {
  return (
    <div className='flex flex-1 flex-col'>
      <Outlet/>
    </div>
  )
}
